/* EVERLOOP: native Shopify cart, variants, gallery and accessible dialogs. */
(() => {
  "use strict";

  const cfg = window.Everloop || {
    root: "/",
    cartUrl: "/cart",
    currency: "TRY"
  };

  const root = cfg.root.endsWith("/") ? cfg.root : cfg.root + "/";
  let cartBusy = false;
  let toastTimer;

  const showToast = text => {
    const node = document.getElementById("Toast");
    if (!node) return;

    node.textContent = text;
    node.classList.add("visible");

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      node.classList.remove("visible");
    }, 3500);
  };

  const money = cents =>
    new Intl.NumberFormat(document.documentElement.lang || "tr", {
      style: "currency",
      currency: cfg.currency
    }).format(cents / 100);

  async function readJson(response) {
    let data;

    try {
      data = await response.json();
    } catch {
      throw new Error(
        "Sunucu yanıtı alınamadı. Lütfen yeniden dene."
      );
    }

    if (!response.ok) {
      throw new Error(
        typeof data.description === "string"
          ? data.description
          : "İşlem tamamlanamadı. Lütfen yeniden dene."
      );
    }

    return data;
  }

  function openDialog(id) {
    const dialog = document.getElementById(id);

    if (
      dialog &&
      typeof dialog.showModal === "function" &&
      !dialog.open
    ) {
      dialog.showModal();
      document.documentElement.classList.add("dialog-open");
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    dialog.close();

    if (!document.querySelector("dialog[open]")) {
      document.documentElement.classList.remove("dialog-open");
    }
  }

  document.addEventListener("click", async event => {
    const open = event.target.closest("[data-open-dialog]");

    if (open) {
      event.preventDefault();
      openDialog(open.dataset.openDialog);
      return;
    }

    const close = event.target.closest("[data-close-dialog]");

    if (close) {
      closeDialog(close.closest("dialog"));
      return;
    }

    const cartLink = event.target.closest("[data-open-cart]");

    if (cartLink) {
      const dialog = document.getElementById("CartDrawer");

      if (!dialog?.showModal) return;

      event.preventDefault();
      openDialog("CartDrawer");

      try {
        await refreshCart();
      } catch {
        showToast(
          "Sepet yenilenemedi. Sepet sayfasından yeniden deneyebilirsin."
        );
      }

      return;
    }

    const remove = event.target.closest("[data-remove-key]");

    if (remove) {
      event.preventDefault();

      if (cartBusy) return;

      await mutateCart("change", {
        id: remove.dataset.removeKey,
        quantity: 0
      });

      return;
    }

    const gallery = event.target.closest("[data-gallery-src]");

    if (gallery) {
      const main = document.getElementById("ProductMainImage");

      if (main) {
        main.src = gallery.dataset.gallerySrc;
        main.removeAttribute("srcset");
        main.alt = gallery.dataset.galleryAlt || "";

        document
          .querySelectorAll("[data-gallery-src]")
          .forEach(element => {
            element.setAttribute(
              "aria-pressed",
              String(element === gallery)
            );
          });
      }
    }
  });

  document.querySelectorAll("dialog").forEach(dialog => {
    dialog.addEventListener("click", event => {
      if (event.target === dialog) {
        const rectangle = dialog.getBoundingClientRect();

        if (
          event.clientX < rectangle.left ||
          event.clientX > rectangle.right ||
          event.clientY < rectangle.top ||
          event.clientY > rectangle.bottom
        ) {
          closeDialog(dialog);
        }
      }
    });

    dialog.addEventListener("close", () => {
      if (!document.querySelector("dialog[open]")) {
        document.documentElement.classList.remove("dialog-open");
      }
    });
  });

  function replaceCart(data) {
    const contents = data.sections?.["cart-fragment"];

    if (contents) {
      const drawer = document.getElementById("CartContents");

      if (drawer) {
        drawer.innerHTML = contents;
      }

      const page = document.querySelector(
        ".native-cart-page .native-cart-form"
      );

      if (page) {
        const template = document.createElement("template");

        template.innerHTML = contents
          .replaceAll("drawer-Quantity-", "page-Quantity-")
          .replaceAll("drawer-Note", "page-Note");

        const replacement =
          template.content.querySelector(".native-cart-form") ||
          template.content.querySelector(".empty-state");

        if (replacement) {
          page.replaceWith(replacement.cloneNode(true));
        }
      }
    }

    document
      .querySelectorAll("[data-cart-count]")
      .forEach(element => {
        element.textContent = String(data.item_count ?? 0);
      });

    const pageCount = document.querySelector(
      ".native-cart-page h1 span"
    );

    if (pageCount) {
      pageCount.textContent = "(" + data.item_count + ")";
    }
  }

  async function refreshCart() {
    const [cart, sections] = await Promise.all([
      fetch(root + "cart.js", {
        headers: { Accept: "application/json" }
      }).then(readJson),

      fetch(cfg.cartUrl + "?sections=cart-fragment", {
        headers: { Accept: "application/json" }
      }).then(readJson)
    ]);

    replaceCart({
      ...cart,
      sections
    });
  }

  async function mutateCart(action, payload) {
    if (cartBusy) return;

    cartBusy = true;

    document
      .querySelectorAll(".native-cart-form")
      .forEach(form => {
        form.setAttribute("aria-busy", "true");
      });

    try {
      const data = await fetch(root + "cart/" + action + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          ...payload,
          sections: ["cart-fragment"],
          sections_url: cfg.cartUrl
        })
      }).then(readJson);

      replaceCart(data);

      if (!data.sections?.["cart-fragment"]) {
        await refreshCart();
      }

      showToast("Sepetin güncellendi.");
    } catch (error) {
      document
        .querySelectorAll("[data-cart-error]")
        .forEach(element => {
          element.textContent = error.message;
        });

      showToast(error.message);
    } finally {
      cartBusy = false;

      document
        .querySelectorAll(".native-cart-form")
        .forEach(form => {
          form.removeAttribute("aria-busy");
        });
    }
  }

  document.addEventListener("submit", async event => {
    const form = event.target;

    if (form.matches(".native-product-form")) {
      event.preventDefault();

      if (form.dataset.busy) return;

      const button = form.querySelector("[data-add-button]");
      const error = form.querySelector("[data-form-error]");
      const original = button.innerHTML;

      if (!form.reportValidity()) return;

      form.dataset.busy = "true";
      button.disabled = true;
      button.textContent = "Ekleniyor…";
      error.textContent = "";

      try {
        await fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: new FormData(form)
        }).then(readJson);

        try {
          await refreshCart();
        } catch {
          window.location.assign(cfg.cartUrl);
          return;
        }

        showToast("Sepetine eklendi ✓");

        /*
         * Mobil cihazlarda sepet otomatik açılmaz.
         * Masaüstünde sepet paneli açılmaya devam eder.
         */
        if (
          !window.matchMedia("(max-width: 767px)").matches
        ) {
          openDialog("CartDrawer");
        }
      } catch (errorMessage) {
        error.textContent = errorMessage.message;
      } finally {
        delete form.dataset.busy;
        button.disabled = false;
        button.innerHTML = original;

        updateVariant(
          form.closest("[data-product-section]"),
          false
        );
      }
    }

    if (form.matches(".native-cart-form")) {
      if (event.submitter?.name === "checkout") return;

      event.preventDefault();

      const updates = {};

      form
        .querySelectorAll("[data-cart-key]")
        .forEach(input => {
          updates[input.dataset.cartKey] = Math.max(
            0,
            Math.floor(Number(input.value) || 0)
          );
        });

      await mutateCart("update", {
        updates,
        note:
          form.querySelector("[name=note]")?.value || ""
      });
    }
  });

  function updateVariant(section, updateUrl = true) {
    if (!section) return;

    const select = section.querySelector(
      "[data-variant-select]"
    );

    if (!select) return;

    const variants = JSON.parse(
      section.querySelector("[data-variants]").textContent
    );

    const variant = variants.find(
      item => String(item.id) === select.value
    );

    if (!variant) return;

    section.querySelector(
      "[data-product-price]"
    ).textContent = money(variant.price);

    const compare = section.querySelector(
      "[data-compare-price]"
    );

    compare.textContent =
      variant.compare_at_price > variant.price
        ? money(variant.compare_at_price)
        : "";

    const button = section.querySelector(
      "[data-add-button]"
    );

    button.disabled = !variant.available;
    button.textContent = variant.available
      ? "Sepete ekle +"
      : "Tükendi";

    section.querySelector("[data-stock]").textContent =
      variant.available
        ? "Seçtiğin ürün mevcut."
        : "Bu seçenek şu anda tükendi.";

    const quantity = section.querySelector(
      "[name=quantity]"
    );

    const rule = variant.quantity_rule || {};

    quantity.min = String(rule.min || 1);
    quantity.step = String(rule.increment || 1);

    if (rule.max) {
      quantity.max = rule.max;
    } else {
      quantity.removeAttribute("max");
    }

    quantity.value = String(rule.min || 1);

    if (variant.featured_image?.src) {
      const image = document.getElementById(
        "ProductMainImage"
      );

      if (image) {
        image.src = variant.featured_image.src;
        image.removeAttribute("srcset");
      }
    }

    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
    }
  }

  function initHeroSlider(slider) {
    if (slider.dataset.heroReady === "true") return;

    slider.dataset.heroReady = "true";

    const slides = [
      ...slider.querySelectorAll("[data-hero-slide]")
    ];

    const dots = [
      ...slider.querySelectorAll("[data-hero-dot]")
    ];

    if (slides.length < 2) return;

    const previous = slider.querySelector(
      "[data-hero-prev]"
    );

    const next = slider.querySelector(
      "[data-hero-next]"
    );

    const play = slider.querySelector(
      "[data-hero-play]"
    );

    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const delay = Math.max(
      4000,
      Number(slider.dataset.interval) || 6000
    );

    let active = 0;
    let timer = null;
    let interacting = false;

    let paused =
      reduced ||
      slider.dataset.autoplay !== "true";

    function show(index) {
      active =
        (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;

        slide.classList.toggle("active", selected);
        slide.setAttribute(
          "aria-hidden",
          String(!selected)
        );

        slide.inert = !selected;
      });

      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;

        dot.classList.toggle("active", selected);

        if (selected) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();

      if (
        !paused &&
        !interacting &&
        !document.hidden
      ) {
        timer = window.setInterval(() => {
          show(active + 1);
        }, delay);
      }
    }

    function syncPlay() {
      if (!play) return;

      play.setAttribute(
        "aria-label",
        paused
          ? "Otomatik geçişi başlat"
          : "Otomatik geçişi duraklat"
      );

      const pauseIcon = play.querySelector(
        "[data-hero-pause]"
      );

      const resumeIcon = play.querySelector(
        "[data-hero-resume]"
      );

      if (pauseIcon) pauseIcon.hidden = paused;
      if (resumeIcon) resumeIcon.hidden = !paused;
    }

    previous?.addEventListener("click", () => {
      show(active - 1);
      start();
    });

    next?.addEventListener("click", () => {
      show(active + 1);
      start();
    });

    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        show(Number(dot.dataset.heroDot));
        start();
      });
    });

    play?.addEventListener("click", () => {
      paused = !paused;
      syncPlay();
      start();
    });

    slider.addEventListener("mouseenter", () => {
      interacting = true;
      stop();
    });

    slider.addEventListener("mouseleave", () => {
      interacting = false;
      start();
    });

    slider.addEventListener("focusin", () => {
      interacting = true;
      stop();
    });

    slider.addEventListener("focusout", event => {
      if (!slider.contains(event.relatedTarget)) {
        interacting = false;
        start();
      }
    });

    document.addEventListener(
      "visibilitychange",
      start
    );

    show(0);
    syncPlay();
    start();
  }

  document
    .querySelectorAll("[data-hero-slider]")
    .forEach(initHeroSlider);

  document.addEventListener("change", event => {
    if (
      event.target.matches("[data-variant-select]")
    ) {
      updateVariant(
        event.target.closest("[data-product-section]")
      );
    }
  });

  document.addEventListener(
    "shopify:section:load",
    event => {
      event.target
        .querySelectorAll("[data-product-section]")
        .forEach(section => {
          updateVariant(section, false);
        });

      event.target
        .querySelectorAll("[data-hero-slider]")
        .forEach(initHeroSlider);
    }
  );/* EVERLOOP — ürün görselleri otomatik geçiş */
function initProductGallery(gallery) {
  if (!gallery || gallery.dataset.autoplayReady === "true") return;

  const mainImage = gallery.querySelector("#ProductMainImage");
  const thumbnails = [...gallery.querySelectorAll("[data-gallery-src]")];

  if (!mainImage || thumbnails.length < 2) return;

  gallery.dataset.autoplayReady = "true";

  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  let activeIndex = thumbnails.findIndex(
    button => button.getAttribute("aria-pressed") === "true"
  );

  if (activeIndex < 0) activeIndex = 0;

  let timer = null;
  let interacting = false;

  function showImage(index) {
    activeIndex = (index + thumbnails.length) % thumbnails.length;

    const selected = thumbnails[activeIndex];
    const newSource = selected.dataset.gallerySrc;

    if (!newSource) return;

    mainImage.classList.add("changing");

    window.setTimeout(() => {
      mainImage.src = newSource;
      mainImage.removeAttribute("srcset");

      if (selected.dataset.galleryAlt) {
        mainImage.alt = selected.dataset.galleryAlt;
      }

      thumbnails.forEach((button, buttonIndex) => {
        button.setAttribute(
          "aria-pressed",
          String(buttonIndex === activeIndex)
        );
      });

      mainImage.classList.remove("changing");
    }, 180);
  }

  function stopAutoplay() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function startAutoplay() {
    stopAutoplay();

    if (reducedMotion || interacting || document.hidden) return;

    timer = window.setInterval(() => {
      showImage(activeIndex + 1);
    }, 5000);
  }

  thumbnails.forEach((button, index) => {
    button.addEventListener("click", () => {
      activeIndex = index;
      startAutoplay();
    });
  });

  gallery.addEventListener("mouseenter", () => {
    interacting = true;
    stopAutoplay();
  });

  gallery.addEventListener("mouseleave", () => {
    interacting = false;
    startAutoplay();
  });

  gallery.addEventListener("focusin", () => {
    interacting = true;
    stopAutoplay();
  });

  gallery.addEventListener("focusout", event => {
    if (!gallery.contains(event.relatedTarget)) {
      interacting = false;
      startAutoplay();
    }
  });

  document.addEventListener("visibilitychange", startAutoplay);

  thumbnails.forEach((button, index) => {
    button.setAttribute("aria-pressed", String(index === activeIndex));
  });

  startAutoplay();
}

document
  .querySelectorAll(".native-gallery")
  .forEach(initProductGallery);

document.addEventListener("shopify:section:load", event => {
  event.target
    .querySelectorAll(".native-gallery")
    .forEach(initProductGallery);
});
})();